<template>
  <div class="search">
    <home-banner ref="homeBanner" :height="339"></home-banner>
    <div class="searchMain">
      <div class="searchMainBox main_panel">
        <div class="pull-left silder">
          <div class="silder_title">
            <a href="/">{{mathedTitle}}</a>
          </div>
          <div class="silder_content">
            <ul>
              <li>
                <a class="silder_first_a">
                  {{mathedTitle}}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="pull-right background_color_white section_panel">
          <div class="section_panel_title">
            <div class="pull-left t_l">{{mathedTitle}}</div>
            <div class="pull-right t_r">
              <i class="iconfont">&#xe727;</i> 
              您当前所在位置：<a href="/">首页</a>   
              <a> &gt; {{mathedTitle}}</a>  
            </div>
          </div>
          <div class="news_list_content">
            <div id="NewsList">
              <ul>
                <li v-for="(item,index) in searchList" :key="index">
                  <div class="pull-left text">
                    <a v-if="item.url && item.url !== ''" :href="item.url" target="_blank" title="">{{item.title | ellipsis2}}</a>
                    <a v-else :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`" target="_blank" >{{item.title | ellipsis2}}</a>
                  </div>
                  <div class="pull-right date">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</div>
                </li>
              </ul>
            </div>
            <div class="listPagination">
              <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                :pager-count="11"
                @current-change="currentChange">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>    
</template>

<script>
import { articleSearch } from '@/api/common'
import homeBanner from "@/components/swiper.vue"
export default {
  components: {
      homeBanner
    },
  data() {
    return {    
      searchList: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,  
      searchValue:'',
      mathedTitle:'搜索结果',     
    }
  },
  filters: {
      //超过100位显示 ...
      ellipsis2: function(value) {
        if (!value) return "";
        if (value.length > 35) {
          return value.slice(0, 35) + "...";
        }
        return value;
      },
    }, 
  computed: {
  },
  mounted() {
    var _this = this
    _this.searchValue = _this.$route.params.title
    _this.articles()
  },
  methods: {
    articles() {
      var _this = this

      let data = {
        entTApplicationUuid: _this.webId,
        title: _this.searchValue,
        pageNum: _this.pageNum,
        pageSize: _this.pageSize
      }
      articleSearch(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.searchList = data.rows
          _this.total = data.totalRows
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    currentChange(e) {
      var _this = this
      _this.pageNum = e
      _this.articles()
    }
    
  },
}
</script>

<style lang="scss">
/* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: 'iconfont';  /* Project id 3165120 */
  src: url('//at.alicdn.com/t/c/font_3165120_p18lpcmi1in.woff2?t=1664259445543') format('woff2'),
       url('//at.alicdn.com/t/c/font_3165120_p18lpcmi1in.woff?t=1664259445543') format('woff'),
       url('//at.alicdn.com/t/c/font_3165120_p18lpcmi1in.ttf?t=1664259445543') format('truetype');
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 22px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.1px;
  -moz-osx-font-smoothing: grayscale;
  color: #367cbd;
}
.searchMain {
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: #ebebeb;
  padding-top: 30px;
}
.searchMainBox {
  background-color: #fff;
  margin-top: 30px;
}
.main_panel{
  width: 1200px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.searchMain .silder {
  width: 226px;
  height: auto;
  overflow: hidden;
  margin: 30px 0px 0px 18px;
}
.pull-left {
  float: left!important;
}
.searchMain .silder .silder_title {
  width: 226px;
  height: 63px;
  overflow: hidden;
  text-indent: 36px;
  background-color: #0063b1;
}
.searchMain .silder .silder_title {
  width: 226px;
  height: 63px;
  overflow: hidden;
  text-indent: 36px;
  background-color: #0063b1;
}
.searchMain .silder .silder_title a {
  color: #fff;
  font-size: 24px;
  line-height: 63px;
  font-weight: bold;
}
.searchMain .silder_content {
  width: 226px;
  height: auto;
  overflow: hidden;
  min-height: 600px;
}
ul, ol {
  list-style: none;
  margin-bottom: 0px !important;
}
.searchMain .silder_content ul li {
  width: 226px;
  height: auto;
  overflow: hidden;
  border-bottom: solid 1px #dadada;
}
.searchMain .silder_content ul li a.on {
  background-color: #f0f0f0;
  border-left: solid 7px #0063b1;
  color: #0063b1;
  font-weight: bold;
}
.searchMain .silder_content ul li a.silder_first_a {
  display: block;
  cursor: pointer;
  width: 226px;
  height: 53px;
  overflow: hidden;
  text-indent: 36px;
  color: #000;
  font-size: 18px;
  line-height: 53px;
  background-color: #f0f0f0;
  border-left: solid 7px #0063b1;
  color: #0063b1;
  font-weight: bold;
}
.searchMain .section_panel {
  width: 956px;
  height: auto;
  overflow: hidden;
  margin-top: 30px;
  border-left: solid 1px #e6e6e6;
  box-sizing: border-box;
}
.pull-right {
  float: right!important;
}
.searchMain .section_panel .section_panel_title {
  width: 100%;
  height: 65px;
  overflow: hidden;
  border-bottom: solid 1px #e6e6e6;
}
.searchMain .section_panel .section_panel_title .t_l {
  height: 65px;
  overflow: hidden;
  margin-left: 30px;
  padding-left: 20px;
  color: #367cbd;
  line-height: 65px;
  font-size: 23px;
  background-image: url(../assets/kg/page_title_bg.png);
  background-position: left center;
  background-repeat: no-repeat;
}
.searchMain .section_panel .section_panel_title .t_r {
  height: 65px;
  overflow: hidden;
  text-align: right;
  color: #575757;
  line-height: 65px;
  font-size: 14px;
  margin-right: 45px;
}
.searchMain .section_panel .section_panel_title .t_r a {
  color: #575757;
  line-height: 65px;
  font-size: 14px;
}
.news_list_content {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.news_list_content #NewsList ul {
  margin: 12px 30px;
  width: auto;
  height: auto;
  overflow: hidden;
}
.news_list_content #NewsList ul li {
  width: 100%;
  height: 60px;
  overflow: hidden;
  border-bottom: dashed 1px #a8a9aa;
}
.news_list_content #NewsList ul li .text {
  height: 60px;
  overflow: hidden;
  position: relative;
  margin-left: 30px;
}
.news_list_content #NewsList ul li .date {
  height: 60px;
  overflow: hidden;
  color: #000000;
  font-size: 17px;
  line-height: 60px;
  margin-right: 30px;
}
.news_list_content #NewsList ul li .text a {
  color: #000000;
  font-size: 17px;
  line-height: 60px;
  padding-left: 26px;
}
.news_list_content #NewsList ul li .text a::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 4px solid;
  border-color: #0063b1;
  border-radius: 4px;
  top: 27px;
  left: 0px;
}
.listPagination{
  width: 100%;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>

